/**
 * ECharts 提供的标记类型包括
 * 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow', 'none'
 */
export const ECHARTS_SYMBOL = [
  // 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow', 'none'
  {
    label: 'circle',
    value: 'circle'
  },
  {
    label: 'rect',
    value: 'rect'
  },
  {
    label: 'roundRect',
    value: 'roundRect'
  },
  {
    label: 'triangle',
    value: 'triangle'
  },
  {
    label: 'diamond',
    value: 'diamond'
  },
  {
    label: 'pin',
    value: 'pin'
  },
  {
    label: 'arrow',
    value: 'arrow'
  },
  {
    label: 'none',
    value: 'none'
  }
]
/**
 * 标签的位置,
 * 可以通过内置的语义声明位置:
 * top / left / right / bottom / inside / insideLeft / insideRight / insideTop / insideBottom / insideTopLeft / insideBottomLeft / insideTopRight / insideBottomRight
 */
export const ECHARTS_LABEL_POSITION = [
  { label: 'top', value: 'top' },
  { label: 'left', value: 'left' },
  { label: 'right', value: 'right' },
  { label: 'bottom', value: 'bottom' },
  { label: 'inside', value: 'inside' },
  { label: 'insideLeft', value: 'insideLeft' },
  { label: 'insideRight', value: 'insideRight' },
  { label: 'insideTop', value: 'insideTop' },
  { label: 'insideBottom', value: 'insideBottom' },
  { label: 'insideTopLeft', value: 'insideTopLeft' },
  { label: 'insideBottomLeft', value: 'insideBottomLeft' },
  { label: 'insideTopRight', value: 'insideTopRight' },
  { label: 'insideBottomRight', value: 'insideBottomRight' }
]
/**
 * 指定另一个坐标系组件，本 series-effectScatter 布局在那个坐标系中。
 */
export const ECHARTS_COORDINATE_SYSTEM = [
  { label: 'cartesian2d', value: 'cartesian2d' },
  { label: 'polar', value: 'polar' },
  { label: 'geo', value: 'geo' },
  { label: 'singleAxis', value: 'singleAxis' },
  { label: 'calendar', value: 'calendar' },
  { label: 'matrix', value: 'matrix' }
]

export const labelOption = {
  show: true,
  width: '',
  // top / left / right / bottom / inside / insideLeft / insideRight / insideTop / insideBottom / insideTopLeft / insideBottomLeft / insideTopRight / insideBottomRight
  position: 'top',
  // 距离图形元素的距离
  distance: 5,
  rotate: 0,
  color: '#ffffff',
  // 'normal' | 'italic' | 'oblique'
  fontStyle: 'normal',
  // 'normal' | 'bold' | 'bolder' | 'lighter' | 100 | 200 | 300 | 400...
  fontWeight: 'normal',
  fontSize: 12,
  // 'normal' | 'truncate' | 'break' | 'breakAll'
  overflow: 'none'
}

export const itemStyleOption = {
  show: true,
  areaColor: '',
  color: '',
  borderColor: '#000000',
  borderWidth: 0,
  // 'solid' | 'dashed' | 'dotted' | 'double' | 'groove' | 'ridge' | 'inset' | 'outset'
  borderType: 'solid',
  shadowBlur: 0,
  shadowColor: '',
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  opacity: 1
}

export const emphasisOption = {
  disabled: false,
  label: {
    ...labelOption
  },
  itemStyle: {
    ...itemStyleOption
  }
}

export const visualMapOption = {
  show: true,
  type: 'continuous',
  left: 0,
  top: 0,
  right: 0,
  bottom: 0,
  text: ['High', 'Low'],
  realtime: false,
  calculable: true,
  inRange: {
    color: ['#5EBD6F', '#5FBFE5', '#3E82EE']
  },
  textStyle: {
    color: '#fff'
  },
  // 设置'auto'则根据数据进行计算
  min: 'auto',
  max: 'auto',
  z: 4,
  // 指定取哪个系列的数据
  seriesIndex: '0'
}

export const geoOption = {
  show: true,
  // 默认始终与series中的保持一致
  map: '中国',
  zoom: 1,
  itemStyle: {
    ...itemStyleOption
  },
  roam: false,
  aspectScale: 1,
  layoutSize: '100%',
  layoutCenter: ['50%', '50%'],
  zlevel: 1,
  silent: true
}

export const baseMapSeriesOption = {
  type: 'map',
  // 数据列
  dataCol: 'value',
  map: '中国',
  // 默认与最外层的保持一致
  name: '中国',
  // 'series' | 'data'
  colorBy: 'series',
  zoom: 1,
  aspectScale: 1,
  zlevel: 2,
  roam: true,
  layoutSize: '100%',
  layoutCenter: ['50%', '50%'],
  label: {
    ...labelOption
  },
  itemStyle: {
    ...itemStyleOption
  },
  emphasis: {
    ...emphasisOption
  },
  tooltip: {
    formatter: ''
  }
}
// 立柱图层基础信息
export const baseStudOption = {
  type: 'stud',
  // 数据列
  dataCol: 'value',
  // 分组列
  areaCol: '',
  // 坐标系
  coordinateSystem: 'geo',
  // 坐标系对应ID
  geoIndex: 0,
  // 柱状
  lineInfo: {
    zlevel: 5,
    lineStyle: {
      width: 17,
      color: '#c36a0b',
      opacity: 0.7
    },
    label: {
      show: true,
      position: 'end',
      color: '#ffffff',
      fontSize: 12,
      backgroundColor: '#C36A0B',
      padding: 8,
      borderRadius: 0,
      borderColor: '',
      borderWidth: 0,
      borderType: 'solid',
      customLabelHtml: ''
    }
  },
  // 控制顶部文本显示
  topInfo: {
    zlevel: 5,
    symbol: 'diamond',
    symbolSize: [17, 8],
    label: {
      show: false,
      position: 'bottom',
      color: 'fff',
      fontSize: 16,
      backgroundColor: '#C36A0B',
      borderRadius: 5,
      borderColor: '#67F0EF',
      borderWidth: 1
    },
    itemStyle: {
      color: '#F18410',
      opacity: 1
    }
  },
  // 控制底部
  bottomInfo: {
    zlevel: 4,
    symbol: 'diamond',
    symbolSize: [17, 8],
    label: {
      show: false,
      position: 'bottom',
      color: 'fff',
      fontSize: 14,
      distance: 10
    },
    itemStyle: {
      color: '#F18410',
      opacity: 1
    }
  },
  // 控制底部文本显示
  bottomLabelShow: true,
  lines: {
    type: 'lines',
    zlevel: 5,
    effect: {
      show: false,
      symbolSize: 5 // 图标大小
    },
    lineStyle: {
      width: 17, // 尾迹线条宽度
      color: {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [
          {
            offset: 0,
            color: 'rgba(252, 231, 209, 0.6)' // 0% 处的颜色
          },
          {
            offset: 0.5,
            color: 'rgba(195, 106, 11, 0.8)' // 0% 处的颜色
          },
          {
            offset: 0.5,
            color: 'rgba(195, 106, 11, 0.8)' // 0% 处的颜色
          },
          {
            offset: 1,
            color: 'rgba(195, 106, 11, 1)' // 100% 处的颜色
          }
        ],
        global: false // 缺省为 false
      },
      opacity: 0.7, // 尾迹线条透明度
      curveness: 0 // 尾迹线条曲直度
    },
    label: {
      show: true,
      position: 'end',
      // formatter(e) {
      //   const data = customerBatteryCityData[e.dataIndex]
      //   return '{num|' + data.name + ':}{unit|' + data.value + '}'
      // },
      rich: {
        text: {
          backgroundColor: '#C36A0B',
          fontFamily: 'dine-bold',
          fontSize: 12,
          color: '#ffffff',
          padding: 8
        }
      }
    },
    labelLayout: {
      dy: -8
    },
    silent: true,
    // 立柱高度
    data: []
  },
  // 顶部
  topScatter: {
    type: 'scatter',
    coordinateSystem: 'geo',
    geoIndex: 0,
    zlevel: 5,
    label: {
      show: false,
      position: 'bottom',
      // formatter: (params) => this.data[params.dataIndex].value,
      padding: [4, 8],
      backgroundColor: '#003F5E',
      borderRadius: 5,
      borderColor: '#67F0EF',
      borderWidth: 1,
      color: '#67F0EF'
    },
    symbol: 'diamond',
    symbolSize: [17, 8],
    itemStyle: {
      color: '#F18410',
      opacity: 1
    },
    silent: true,
    data: []
  },
  // 尾部
  bottomScatter: {
    type: 'scatter',
    coordinateSystem: 'geo',
    geoIndex: 0,
    zlevel: 4,
    label: {
      formatter: '{b}',
      position: 'bottom',
      color: '#fff',
      fontSize: 12,
      distance: 10,
      show: true
    },
    symbol: 'diamond',
    symbolSize: [17, 8],
    itemStyle: {
      // color: '#F7AF21',
      color: {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 1,
        y2: 0,
        colorStops: [
          {
            offset: 0,
            color: 'rgb(199,145,41)' // 0% 处的颜色
          },
          {
            offset: 0.5,
            color: 'rgb(199,145,41)' // 0% 处的颜色
          },
          {
            offset: 0.5,
            color: 'rgb(223,176,32)' // 0% 处的颜色
          },
          {
            offset: 1,
            color: 'rgb(223,176,32)' // 0% 处的颜色
          },
          {
            offset: 1,
            color: 'rgba(252, 231, 209, 0.6)' // 100% 处的颜色
          }
        ],
        global: false // 缺省为 false
      },
      opacity: 0.7
    },
    silent: true,
    data: []
  }
}

// 立柱图层基础信息
export const baseFlyLineOption = {
  type: 'flyLine',
  sourceCol: 'name',
  targetCol: 'name',
  coordinateSystem: 'geo',
  linesInfo: {
    zlevel: 2,
    effect: {
      show: true,
      period: 4, // 箭头指向速度，值越小速度越快
      trailLength: 0.4, // 特效尾迹长度[0,1]值越大，尾迹越长重
      symbol: 'pin', // 箭头图标
      symbolSize: 6 // 图标大小
    },
    lineStyle: {
      normal: {
        color: '#1DE9B6',
        width: 1, // 线条宽度
        opacity: 0.1, // 尾迹线条透明度
        curveness: 0.3 // 尾迹线条曲直度
      }
    }
  },
  normalEffectScatterInfo: {
    zlevel: 1,
    symbol: 'circle',
    symbolSize: 2,
    rippleEffect: {
      number: 3, // 波纹的数量。
      period: 5, // 动画的周期，秒数。
      scale: 17, // 动画中波纹的最大缩放比例。
      brushType: 'fill' // 波纹的绘制方式，可选 'stroke' 和 'fill'。
    },
    itemStyle: {
      color: '#FFFA00'
    }
  },
  emphasisEffectScatterInfo: {
    zlevel: 1,
    symbol: 'circle',
    symbolSize: 2,
    rippleEffect: {
      number: 3, // 波纹的数量。
      period: 5, // 动画的周期，秒数。
      scale: 17, // 动画中波纹的最大缩放比例。
      brushType: 'fill' // 波纹的绘制方式，可选 'stroke' 和 'fill'。
    },
    itemStyle: {
      color: '#FFFA00'
    }
  },
  normalEffectScatter: {
    type: 'effectScatter',
    coordinateSystem: 'geo',
    showEffectOn: 'render',
    zlevel: 1,
    rippleEffect: {
      number: 3, // 波纹的数量。
      period: 5, // 动画的周期，秒数。
      scale: 17, // 动画中波纹的最大缩放比例。
      brushType: 'fill' // 波纹的绘制方式，可选 'stroke' 和 'fill'。
    },
    itemStyle: {
      color: '#00EEFF'
    },
    symbolSize: 2,
    data: []
  },
  emphasisEffectScatter: {
    type: 'effectScatter',
    coordinateSystem: 'geo',
    showEffectOn: 'render',
    zlevel: 1,
    rippleEffect: {
      number: 4,
      period: 5,
      scale: 21,
      brushType: 'fill'
    },
    itemStyle: {
      color: '#FFFA00'
    },
    symbolSize: 3,
    data: []
  },
  lines: {
    type: 'lines',
    zlevel: 2,
    effect: {
      show: true,
      period: 4, // 箭头指向速度，值越小速度越快
      trailLength: 0.4, // 特效尾迹长度[0,1]值越大，尾迹越长重
      symbol: 'pin', // 箭头图标
      symbolSize: 6 // 图标大小
    },
    lineStyle: {
      normal: {
        color: '#1DE9B6',
        width: 1, // 线条宽度
        opacity: 0.1, // 尾迹线条透明度
        curveness: 0.3 // 尾迹线条曲直度
      }
    },
    data: []
  }
}
